import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Incident from '../incident-details/incident';
import LoadingSpinner from '../loadspinner/loadspinner';

function Stepup(props) {
  const { searchTerm } = props;
  const [caseManagerData, setCaseManagerData] = useState([]);
  const [emptyData, setEmptyData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableSize, setTableSize] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const end_date = new Date().toJSON().slice(0, 10).toString();
  const start_date = new Date(new Date().setMonth(new Date().getMonth() - 4)).toJSON().slice(0, 10).toString();
  const [selectedIncident, setSelectedIncident] = useState(null);

  const tableHeaders = [
    'Session Id',
    'User name',
    'DateTime',
    'Risk Score(%)',
    'Risk Level',
    'User Location',
    'IP Address',
    'User Type'
  ];

  const tableSizeList = [5, 10, 15, 20];

  function filterName(searchTerm) {
    const filterData = caseManagerData.filter(profile =>
      profile.username.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return filterData;
  }

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  var userToken = getCurrentUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${userToken}`
  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const params = `start_date=${props.selected1 == null ? start_date : props.selected1}&end_date=${props.selected2 == null ? end_date : props.selected2}`;
        const response = await axios.get(`https://uat-webauthn.adapid.link/api/v1/passwordless/userdetails?${params}`, { headers });
        const result = response.data;
        const tableData = result.case_manager_data.filter(item => item.usertype === "no");
        setCaseManagerData(tableData.sort((a, b) => {
          const c = +new Date(a.date);
          const d = +new Date(b.date);
          return d - c;
        }));
        setCount(result.total_signin_count);
        setLoading(false);
      } catch (error) {
        if (error.response && error.response.data.message === "No record found") {
          setEmptyData(true);
        }
        if (error.response && error.response.data.msg === "Token has expired") {
          props.onLogout('token');
        }
        setLoading(false);
      }
    };
    getData();
  }, [props.selected1, props.selected2]);

  return (
    <div>
      {selectedIncident ? (
        <Incident selectedIncident={selectedIncident} />
      ) : (
        <>
          {loading ? (<LoadingSpinner />) : (emptyData ? <div className="empty-data" style={{ height: "400px" }}><span>No Results Found</span></div> :
            <div className="main_case">
              <div className="table_case">
                <table >
                  <thead className="tablehead">
                    <tr>
                      {tableHeaders.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {searchTerm ? filterName(searchTerm).slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                      <tr key={index}>
                        <td>{row.session_id}</td>
                        <td>{row.username}</td>
                        <td>
                          {new Date(row.time).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: true,
                            timeZone: 'Asia/Kolkata',
                          })}
                        </td>
                        <td>{row.user_risk_score}</td>
                        <td>{row.risk_level}</td>
                        <td>{row.user_location}</td>
                        <td>{row.source_ip_address}</td>
                        <td>{row.usertype === 'yes' ? 'Legitimate User' : 'Intruder'}</td>
                      </tr>
                    )) :
                      caseManagerData.slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                        <tr key={index}>
                          <td>{row.session_id}</td>
                          <td>{row.username}</td>
                          <td>
                            {new Date(row.time).toLocaleString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: 'numeric',
                              minute: 'numeric',
                              second: 'numeric',
                              hour12: true,
                              timeZone: 'Asia/Kolkata',
                            })}
                          </td>
                          <td>{row.user_risk_score}</td>
                          <td>{row.risk_level}</td>
                          <td>{row.user_location}</td>
                          <td>{row.source_ip_address}</td>
                          <td>{row.usertype === 'yes' ? 'Legitimate User' : 'Intruder'}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="paginator">
                <div className="itemSize">
                  <label htmlFor="tableSize">Items per page:</label>
                  <select
                    name="tableSize"
                    id="tableSize"
                    value={tableSize}
                    onChange={(e) => setTableSize(parseInt(e.target.value))}>
                    {tableSizeList.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="itemValue">
                  <span>
                    {tableSize * (page - 1) + 1}-{Math.min(tableSize * page, count)} of {count}
                  </span>
                </div>
                <div className="item">
                  <button
                    className="previous"
                    onClick={() => onPageChange(page - 1)}
                    disabled={page === 1}>
                    Previous
                  </button>
                  <button
                    className="next"
                    onClick={() => onPageChange(page + 1)}
                    disabled={page === Math.ceil(count / tableSize)}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Stepup;

